import type { CallConversation } from "@/playground/components/DevHome/table/graphql/types";
import { formatInternational } from "@/playground/components/DevHome/table/utilities/phone_number/phone_number.utility";

export const getNumber = (line: CallConversation["line"]) => ({
  name: line?.name,
  countryISOCode: line?.countryISOCode,
  phoneNumber: line?.phoneNumber
    ? formatInternational(line.phoneNumber)
    : undefined,
  lineLanguage: line?.language,
});
